import IconButton from "@common/components/IconButton";
import { useAdminVisitors } from "../library/queries";

const when = (iso: string | null) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");

/** Who has used CloudBoy, by address, from the kast-dev central visitor log (GET /admin/visitors). */
export default function AdminVisitors() {
  const visitors = useAdminVisitors();
  const rows = visitors.data ?? [];
  const sessions = rows.reduce((n, v) => n + v.count, 0);
  return (
    <section className="panel">
      <div className="section-head">
        <h2>Visitors</h2>
        <IconButton icon="refresh" label="Refresh" onClick={() => void visitors.refetch()} disabled={visitors.isFetching} />
      </div>
      {visitors.error ? (
        <p className="notice error">Could not load visitors.</p>
      ) : visitors.isLoading ? (
        <p className="muted small">Loading…</p>
      ) : (
        <>
          <p className="muted small">
            {rows.length} {rows.length === 1 ? "address" : "addresses"} · {sessions} {sessions === 1 ? "session" : "sessions"} · a
            session ends after 5 minutes idle
          </p>
          {rows.length === 0 ? (
            <p className="muted small">No visitors logged yet.</p>
          ) : (
            <div className="visitor-table">
              <table>
                <thead>
                  <tr>
                    <th>IP</th>
                    <th className="number">Sessions</th>
                    <th>First seen</th>
                    <th>Last seen</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((v) => (
                    <tr key={v.ip}>
                      <td className="mono">{v.ip}</td>
                      <td className="number">{v.count.toLocaleString()}</td>
                      <td>{when(v.first_seen)}</td>
                      <td>{when(v.last_seen)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </section>
  );
}
